import type { FC } from 'react';
import { cn } from 'shared/lib';

const Divider: FC<{ className?: string }> = ({ className }) => {
  return <div className={cn('ag-border-b ', className)} />;
};

export default Divider;
